import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TutorialState {
  lastTutorial: Record<string, string>; // courseSlug -> tutorialSlug
  setLastTutorial: (courseSlug: string, tutorialSlug: string) => void;
  getLastTutorial: (courseSlug: string) => string | null;
}

export const useTutorialStore = create<TutorialState>()(
  persist(
    (set, get) => ({
      lastTutorial: {},
      setLastTutorial: (courseSlug: string, tutorialSlug: string) => {
        set((state) => ({
          lastTutorial: {
            ...state.lastTutorial,
            [courseSlug]: tutorialSlug,
          },
        }));
      },
      getLastTutorial: (courseSlug: string) => {
        return get().lastTutorial[courseSlug] || null;
      },
    }),
    {
      name: 'tutorial-storage',
    }
  )
);
